Swiper = require('../lib/swiper')

$(document).ready(function(){

// sliders

	var swiperBanner = new Swiper ('.swiper-banner .swiper-container', {
		slidesPerView: "1",
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		pagination: {
			el: '.swiper-banner .swiper-pagination',
			clickable: true,
		},
	});

	var carsSwiper = undefined;
	function initCarsSwiper() {
		var screenWidth = $(window).outerWidth();
		if ( (screenWidth < (1280)) && (carsSwiper == undefined)) {
			carsSwiper = new Swiper ('.swiper-cars .swiper-container', {
				slidesPerView: 1,
				spaceBetween: 15,
				navigation: {
					nextEl: '.hits-screen .swiper-button-next',
					prevEl: '.hits-screen .swiper-button-prev',
				},
				breakpoints: {
					640: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
				}
			});
		} else if ((screenWidth > 1279) && (carsSwiper != undefined)) {
		  carsSwiper.destroy();
		  carsSwiper = undefined;
		  $('.swiper-cars .swiper-wrapper').removeAttr('style');
		  $('.swiper-cars .swiper-slide').removeAttr('style');
		}
	}
	initCarsSwiper();

	$(window).resize(function() {
		initCarsSwiper();
	});

    var colorsSwiper = undefined;
    function initColorsSwiper() {
        var screenWidth = $(window).outerWidth();
        if ( (screenWidth < (768)) && (colorsSwiper == undefined)) {
            colorsSwiper = new Swiper ('.swiper-colors .swiper-container', {
                slidesPerView: 6,
                navigation: {
                    nextEl: '.swiper-colors .swiper-button-next',
                    prevEl: '.swiper-colors .swiper-button-prev',
                },
                breakpoints: {
                    400: {
                        slidesPerView: 8,
                    },
                }
            })
        } else if ((screenWidth > 767) && (colorsSwiper != undefined)) {
            colorsSwiper.destroy();
            colorsSwiper = undefined;
            $('.swiper-colors .swiper-wrapper').removeAttr('style');
            $('.swiper-colors .swiper-slide').removeAttr('style');
        }
    };
    initColorsSwiper();

    $(window).resize(function() {
        initColorsSwiper();
    });

	var swiperSpecial = new Swiper ('.swiper-special .swiper-container', {
		slidesPerView: "1",
		spaceBetween: 20,
		loop: true,
		navigation: {
			nextEl: '.swiper-special .swiper-button-next',
			prevEl: '.swiper-special .swiper-button-prev',
		},
		pagination: {
			el: '.swiper-special .swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: "3",
				spaceBetween: 20,
			},
		}
	});

	if ('undefined' !== typeof(swiperSpecial) && 'undefined' !== typeof(swiperSpecial.slides)) {
        var indexSpecial = swiperSpecial.slides.length;
        swiperSpecial.slideTo(indexSpecial / 2);
    }

	var swiperReviews = new Swiper ('.swiper-reviews .swiper-container', {
		slidesPerView: 1,
		slidesPerColumn: 1,
		spaceBetween: 15,
		pagination: {
			el: '.swiper-reviews .swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.reviews-screen .swiper-button-next',
			prevEl: '.reviews-screen .swiper-button-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				slidesPerColumn: 2,
				spaceBetween: 0,
			},
		}
	});

	var swiperPartners = new Swiper ('.swiper-partners .swiper-container', {
		slidesPerView: "1",
		spaceBetween: 15,
		navigation: {
			nextEl: '.partners-screen .swiper-button-next',
			prevEl: '.partners-screen .swiper-button-prev',
		},
		pagination: {
			el: '.partners-screen .swiper-pagination',
			type: 'fraction',
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 15,
			},
			1366: {
				slidesPerView: 6,
				spaceBetween: 15,
			},
		}
	});

	var swiperPhotos = new Swiper ('.swiper-photos .swiper-container', {
		slidesPerView: "auto",
		loop: true,
		navigation: {
			nextEl: '.swiper-photos .swiper-button-next',
			prevEl: '.swiper-photos .swiper-button-prev',
		},
	});
});
